/**
 * Medieval-themed notification icons
 */

import { NotificationType } from "@/types";

export const getNotificationIcon = (type: NotificationType): string => {
  switch (type) {
    // Challenge/Match flow notifications
    case NotificationType.CHALLENGE_SENT:
      return "⚔️"; // Crossed swords for challenge announcement
    case NotificationType.CHALLENGE_EXPIRED:
      return "⏳"; // Hourglass
    case NotificationType.CHALLENGE_CANCELLED:
      return "❌"; // Cancelled
    case NotificationType.CHALLENGE_DECLINED:
      return "🐔"; // Chicken for declined braveheart challenge
    case NotificationType.WALKOVER:
      return "🙌"; // Hands up for walkover/forfeit

    // Match notifications
    case NotificationType.MATCH_SCHEDULED:
      return "📜"; // Scroll/parchment
    case NotificationType.MATCH_RESULT:
      return "👑"; // Crown for victory
    case NotificationType.MATCH_CANCELLED:
      return "❌"; // Cancelled match

    // Ranking notifications
    case NotificationType.RANK_CHANGED:
      return "⬆️"; // Ranking up

    // Team management notifications
    case NotificationType.JOIN_REQUEST:
      return "🏰"; // Castle for team
    case NotificationType.JOIN_REQUEST_APPROVED:
      return "✅"; // Approved
    case NotificationType.JOIN_REQUEST_REJECTED:
      return "⛔"; // Rejected
    case NotificationType.TEAM_INVITATION:
      return "📯"; // Herald/trumpet
    case NotificationType.TEAM_JOINED:
      return "🎉"; // New team celebration
    case NotificationType.TEAM_UPDATE:
      return "📝"; // Team update/news
    case NotificationType.TEAM_VACATION:
      return "🏖️"; // Beach/vacation
    case NotificationType.MEMBER_JOINED:
      return "🎊"; // Celebration
    case NotificationType.MEMBER_LEFT:
      return "🚪"; // Door/exit
    case NotificationType.POOL_PLAYER_JOINED:
      return "🙋"; // Hand raised for free player looking for teammate
    case NotificationType.POOL_TEAM_FORMED:
      return "🤝"; // Handshake for two free players forming a team
    case NotificationType.POOL_REQUEST:
      return "💌"; // Letter for an interest request

    // Organizer notifications
    case NotificationType.ORGANIZER_MESSAGE:
      return "📣"; // Megaphone for organizer announcement

    // Application notifications
    case NotificationType.APPLICATION_MESSAGE:
      return "♖"; // Tower for app-wide announcement

    // Achievements
    case NotificationType.ACHIEVEMENT_CHANGED:
      return "🏅"; // Medal for achievement ownership change

    default:
      return "📢"; // Default announcement
  }
};

// Color scheme for notification types using HeroUI semantic colors
export const getNotificationColor = (type: NotificationType): string => {
  switch (type) {
    case NotificationType.CHALLENGE_SENT:
      return "text-warning-400";
    case NotificationType.CHALLENGE_EXPIRED:
      return "text-danger-400";
    case NotificationType.CHALLENGE_CANCELLED:
      return "text-danger-400";
    case NotificationType.CHALLENGE_DECLINED:
      return "text-warning-400";
    case NotificationType.WALKOVER:
      return "text-warning-400";
    case NotificationType.MATCH_CANCELLED:
      return "text-danger-400";
    case NotificationType.MATCH_RESULT:
      return "text-primary-300";
    case NotificationType.RANK_CHANGED:
      return "text-quest-400";
    case NotificationType.TEAM_JOINED:
    case NotificationType.POOL_TEAM_FORMED:
      return "text-success-400";
    case NotificationType.POOL_PLAYER_JOINED:
      return "text-primary-400";
    case NotificationType.TEAM_UPDATE:
      return "text-primary-400";
    case NotificationType.TEAM_VACATION:
      return "text-warning-400";
    case NotificationType.ORGANIZER_MESSAGE:
      return "text-primary-400";
    case NotificationType.APPLICATION_MESSAGE:
      return "text-warning-500";
    case NotificationType.ACHIEVEMENT_CHANGED:
      return "text-crown";
    default:
      return "text-default-500";
  }
};
